import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';

const API_URL = process.env.NEXT_PUBLIC_API_URL;


// Fetch all products
export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async ({payload}, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/products`;
      const cacheKey = generateCacheKey(url, 'GET', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.get(url, { params:payload });
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

export const fetchRelatedProducts = createAsyncThunk(
  'products/fetchRelatedProducts',
  async ({payload}, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/products`;
      const cacheKey = generateCacheKey(url, 'GET', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.get(url, { params:payload });
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

export const fetchProductDetails = createAsyncThunk(
  'products/fetchProductDetails',
  async ({payload, product_id}, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/product/${product_id}`;
      const cacheKey = generateCacheKey(url, 'GET', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.get(url, { params:payload });
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

export const fetchProductDetailsBySlug = createAsyncThunk(
  'products/fetchProductDetailsBySlug',
  async ({ currentSlug }, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/product-detail/${currentSlug}`;
      const cacheKey = generateCacheKey(url, 'GET');
      return await withManualCache(cacheKey, async () => {
        const response = await axios.get(url);
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    products: [],
    relatedProducts : [],
    productDetails: null,
    status: 'idle',
    error: null,
    detailsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all products fetching
      .addCase(fetchProducts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      .addCase(fetchRelatedProducts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRelatedProducts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.relatedProducts = action.payload;
      })
      .addCase(fetchRelatedProducts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // .addCase(fetchProductDetails.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchProductDetails.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.productDetails = action.payload;
      // })
      // .addCase(fetchProductDetails.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.detailsError = action.payload;
      // })

      .addCase(fetchProductDetailsBySlug.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProductDetailsBySlug.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.productDetails = action.payload;
      })
      .addCase(fetchProductDetailsBySlug.rejected, (state, action) => {
        state.status = 'failed';
        state.detailsError = action.payload;
      });
  },
});

export default productsSlice.reducer;
